function generateNoImageCycleSvg(name) {
  
  if (!name) {
    name = "";
  } else {
    name = String(name);
  }

  const maxLength = 55; // Maximum length of text before breaking into two lines
  let firstLine = name;
  let secondLine = "";

  if (name.length > maxLength) {
    const words = name.split(" ");
    firstLine = "";
    secondLine = "";

    for (const word of words) {
      if ((firstLine + word).length <= maxLength) {
        firstLine += `${word} `;
      } else {
        secondLine += `${word} `;
      }
    }
  }

  firstLine = firstLine.trim();
  secondLine = secondLine.trim();

  const svgWidth = 160; // 16 units width
  const svgHeight = 90; // 9 units height

  const svg = `
    <svg width="${svgWidth}" height="${svgHeight}" viewBox="0 0 ${svgWidth} ${svgHeight}" xmlns="http://www.w3.org/2000/svg">
      <rect width="${svgWidth}" height="${svgHeight}" fill="#1A1E25"/>
      <text x="50%" y="40%" dominant-baseline="central" text-anchor="middle" font-size="4" fill="white" font-family="Inter, sans-serif" font-weight="normal" opacity=".5">No thumbnail</text>
      <text x="50%" y="50%" dominant-baseline="central" text-anchor="middle" font-size="5" fill="white" font-family="Inter, sans-serif" font-weight="bold">${firstLine}</text>
      ${
        secondLine
          ? `<text x="50%" y="60%" dominant-baseline="central" text-anchor="middle" font-size="5" fill="white" font-family="Inter, sans-serif" font-weight="bold">${secondLine}</text>`
          : ""
      }
    </svg>
  `;

  function toBase64Unicode(str) {
    return btoa(
      encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode("0x" + p1);
      })
    );
  }

  return `data:image/svg+xml;base64,${toBase64Unicode(svg)}`;
}

export default generateNoImageCycleSvg;
